package com.exura.features.plandefinition.data.remote.dto.plan

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("preparation_plan")
data class PreparationPlanDto(
    override val title: String,
    override val description: String,
    override val durationInDays: Int? = null,
    override val imageUrl: String? = null,
) : BasePlanDto()